// extracted by mini-css-extract-plugin
module.exports = {"tab_wrapper":"horizontalTab_tab_wrapper__vw3K7","active":"horizontalTab_active__1GiLa"};